import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03766986"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backers" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "backers-title" }, " Backed by ", -1))
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "backers-separation-line" }, null, -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src", "alt"]

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/autoplay'

// companies
import * as starkwareIcon from '@/assets/logos/starkware.svg'
import * as safeIcon from '@/assets/logos/safe.svg'
import * as nethermindIcon from '@/assets/logos/nethermind.svg'
import * as fActorIcon from '@/assets/logos/factor.svg'
import * as dialecticIcon from '@/assets/logos/dialectic.svg'
import * as jsquareIcon from '@/assets/logos/jsquare.svg'
import * as dfgIcon from '@/assets/logos/dfg.svg'
import * as iqtech from '@/assets/logos/iqtech.svg'
import * as nextwebIcon from '@/assets/logos/nextweb_new.svg'

// people
import * as MakotoInoue from '@/assets/backers-people/Makoto Inoue.png'
import * as PatricioWorthalter from '@/assets/backers-people/Patricio Worthalter.png'
import * as WillHarborne from '@/assets/backers-people/Will Harborne.png'
import * as RyanZurrer from '@/assets/backers-people/Ryan Zurrer.png'
import * as DeanEigenmann from '@/assets/backers-people/Dean Eigenmann.png'
import * as ChrisWaclawek from '@/assets/backers-people/Chris Waclawek.png'
import * as KenNg from '@/assets/backers-people/Ken Ng.png'
import * as TimBeiko from '@/assets/backers-people/Tim Beiko.png'
import * as Ozan from '@/assets/backers-people/Ozan.png'
import * as MarioHavel from '@/assets/backers-people/Mario Havel.png'

/*
// missing functional setup for start animation
*/
// import { onMounted, ref } from 'vue'

// const swiperCompanies = ref()
// const swiperCompaniesRef = ref()
// function getRef (swiperInstance: typeof Swiper | any) {
//   swiperCompanies.value = swiperInstance
// }

// const stopAnimation = () => {
//   // swiperCompanies.value.autoplay.stop()
//   const currentTranslate = swiperCompanies.value.getTranslate()
//   // swiperCompanies.value.setTransition(0)
//   swiperCompanies.value.setTranslate(currentTranslate)
//   // swiperCompanies.value.destroy(false, false)
// }

// const startAnimation = () => {
//   // swiperCompanies.value.slideNext()
//   const currentTranslate = swiperCompanies.value.getTranslate()
//   swiperCompanies.value.setTranslate(currentTranslate)
//   // swiperCompanies.value.update()
//   // swiperCompanies.value.autoplay.start()
//   swiperCompaniesRef.value.$el.style.translate = '-1px'
//   // swiperCompanies.value.setTransition(3500)
//   console.log('swiperCompaniesRef.value: ', swiperCompaniesRef.value)
//   // swiperCompaniesRef.value
// }

// swiperCompanies.value.on('touchMove', function () {
//   console.log('touchMove')
// })

// swiperCompanies.value.on('update', function () {
//   console.log('update')
// })

// onMounted(() => {
//   swiperCompaniesRef.value.$el.addEventListener('mouseenter', () => {
//     stopAnimation()
//   })
//   swiperCompaniesRef.value.$el.addEventListener('mouseleave', () => {
//     startAnimation()
//   })
// })


export default /*#__PURE__*/_defineComponent({
  __name: 'Backers',
  setup(__props) {

const companies = [
  {
    link: 'https://starkware.co/',
    img: starkwareIcon.default,
    name: 'Starkware',
  },
  {
    link: 'https://safe.global/',
    img: safeIcon.default,
    name: 'Safe',
  },
  {
    link: 'https://www.nethermind.io/',
    img: nethermindIcon.default,
    name: 'Nethermind',
  },
  {
    link: 'https://f.actor/',
    img: fActorIcon.default,
    name: 'f.actor',
  },
  {
    link: 'https://www.jsquare.co/',
    img: jsquareIcon.default,
    name: 'Jsquare',
  },
  {
    link: 'https://dialectic.ch/',
    img: dialecticIcon.default,
    name: 'Dialectic',
  },
  {
    link: 'https://www.dfg.group/',
    img: dfgIcon.default,
    name: 'DFG',
  },
  {
    link: 'https://www.iqtec.com/',
    img: iqtech.default,
    name: 'IQtec',
  },
  {
    link: 'https://nextweb.capital/',
    img: nextwebIcon.default,
    name: 'Nextweb',
  },
]

const backers = [
  {
    name: 'Makoto Inoue',
    twitterLink: 'https://twitter.com/makoto_inoue',
    img: MakotoInoue.default,
  },
  {
    name: 'Patricio Worthalter',
    twitterLink: 'https://twitter.com/worthalter',
    img: PatricioWorthalter.default,
  },
  {
    name: 'Will Harborne',
    twitterLink: 'https://twitter.com/will_harborne',
    img: WillHarborne.default,
  },
  {
    name: 'Ryan Zurrer',
    twitterLink: 'https://twitter.com/kukulabanze',
    img: RyanZurrer.default,
  },
  {
    name: 'Dean Eigenmann',
    twitterLink: 'https://twitter.com/DeanEigenmann',
    img: DeanEigenmann.default,
  },
  {
    name: 'Chris Waclawek',
    twitterLink: 'https://twitter.com/chriswaclawek',
    img: ChrisWaclawek.default,
  },
  {
    name: 'Ken Ng',
    twitterLink: 'https://twitter.com/nkennethk',
    img: KenNg.default,
  },
  {
    name: 'Tim Beiko',
    twitterLink: 'https://twitter.com/TimBeiko',
    img: TimBeiko.default,
  },
  {
    name: 'Ozan',
    twitterLink: 'https://twitter.com/ozan_yes',
    img: Ozan.default,
  },
  {
    name: 'Mario Havel',
    twitterLink: 'https://twitter.com/TMIYChao',
    img: MarioHavel.default,
  },
]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(Swiper), {
      ref: "swiperCompaniesRef",
      "slides-per-view": 5,
      loop: true,
      modules: [_unref(Autoplay)],
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        waitForTransition: true,
      },
      speed: 3500,
      class: "backers-companies backers__swiper"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(companies, (company) => {
          return _createVNode(_unref(SwiperSlide), {
            key: company.name,
            class: _normalizeClass(["backers-companies__company", {
          'backers-companies__company--nextweb': company.name === 'Nextweb',
        }])
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: company.link,
                class: "backers-companies__link",
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: company.img,
                  alt: company.name
                }, null, 8, _hoisted_4)
              ], 8, _hoisted_3)
            ]),
            _: 2
          }, 1032, ["class"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modules"]),
    _hoisted_5,
    _createVNode(_unref(Swiper), {
      "slides-per-view": 6,
      loop: true,
      modules: [_unref(Autoplay)],
      "free-mode": "",
      "free-mode-momentum": true,
      autoplay: {
        reverseDirection: true,
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        waitForTransition: true,
      },
      speed: 3500,
      pagination: {
        clickable: true,
      },
      class: "backers-people backers__swiper"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(backers, (backer) => {
          return _createVNode(_unref(SwiperSlide), {
            key: backer.name,
            class: "backers-person"
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: backer.twitterLink,
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  class: "backers-person__image",
                  src: backer.img,
                  alt: backer.name
                }, null, 8, _hoisted_7)
              ], 8, _hoisted_6)
            ]),
            _: 2
          }, 1024)
        }), 64))
      ]),
      _: 1
    }, 8, ["modules"])
  ]))
}
}

})